<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
     <vue-perfect-scrollbar class="scroll-area">
      <vs-tabs :key="refreshKey">
    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>

    <vs-tab label="Driver Profile" icon="dashboard" @click="colorx = '#8B0000'">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input
            label="Full Name"
            v-model="driverInfo.fullName"
            class="w-full mt-4"
          />
          <vs-input
            type="date"
            label="Date of Birth"
            v-model="driverInfo.dob"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="Mobile No."
            v-model="driverInfo.mobileNumber"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="IC No."
            v-model="driverInfo.icNumber"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="GDL No."
            v-model="driverInfo.gdlNumber"
            class="w-full mt-4"
          />
          <vs-input
            type="date"
            label="GDL Expiry Date"
            v-model="driverInfo.gdlExpiry"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="Fuel Card No."
            v-model="driverInfo.fuelCard"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="Touch N Go Card No."
            v-model="driverInfo.touchNGo"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="Radio Set No."
            v-model="driverInfo.radioSetNumber"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="Licence No."
            v-model="driverInfo.licenceNumber"
            class="w-full mt-4"
          />
          <vs-input
            type="date"
            label="Licence Expiry Date"
            v-model="driverInfo.licenceExpiry"
            class="w-full mt-4"
          />
          <vs-textarea
            v-model="driverInfo.address"
            label="Address"
            class="mb-0 md:mt-10 mt-6"
            rows="3"
          />
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <vs-input
            type="text"
            label="Driver App Username"
            v-model="driverInfo.driverUsername"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="Driver App Password."
            v-model="driverInfo.driverPassword"
            class="w-full mt-4"
          />
          <vs-textarea
            v-model="driverInfo.remarks"
            label="Remarks"
            class="mb-0 md:mt-10 mt-6"
            rows="3"
          />
          <br />
          <label for="myvueDropZone">Upload Recent Images</label>

          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            v-on:vdropzone-success="vehicleImagesUpload"
            v-on:vdropzone-removed-file="vehicleImagesRemove"
          ></vue-dropzone>
        </div>
      </div>
    </vs-tab>
    <vs-tab label="Documents" icon="event" @click="colorx = '#8B0000'">
      <vx-card style="min-height: 500px">
        <p>
          Take a moment to <b>Upload Vehicle Documents</b> for record keeping &
          receive timely notifications. <br /><vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-layout"
            @click="addAlarm"
            >Add Document</vs-button
          >
        </p>
        <table class="responsive">
          <tr>
            <th>No.</th>
            <th>Name</th>
            <th>Expiry [Date]</th>
            <th>Documents</th>
            <th>Remarks</th>
            <th>Actions</th>
          </tr>

          <tr :key="indextr" v-for="(tr, indextr) in driverAlarm">
            <td>
              <span>
                <b>{{ indextr + 1 }}.</b></span
              >
            </td>
            <td>
              <v-select
                placeholder="Type"
                clearable="false"
                taggable
                :options="[
                  'Road Tax',
                  'Permit',
                  'Puspakom',
                  'Summons',
                  'Insurance',
                  'Make My Own',
                ]"
                v-model="driverAlarm[indextr].type"
              />
            </td>
            <td>
              <input
                type="date"
                v-model="driverAlarm[indextr].date"
                class="w-full mt-5"
              />
            </td>
            <td>
              <li v-for="(item, index) in driverAlarm[indextr].documents">
                <a :href="item" target="_blank">{{
                  'https://fleets.igeotechgps.com/' + item
                }}</a>
              </li>
              <vue-dropzone
                ref="myVueDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-success="vehicleDocumentsUpload"
                v-on:vdropzone-removed-file="vehicleImagesRemove"
              ></vue-dropzone>
            </td>
            <td>
              <vs-textarea
                v-model="driverAlarm[indextr].remark"
                class="w-full mt-5"
                rows="4"
              />
            </td>
            <td>
              <vs-button color="danger" @click="removeAlarm(indextr)"
                >Remove</vs-button
              >
              &nbsp;
            </td>
          </tr>
        </table>

        <br /><vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-layout"
          @click="updateFleets"
          >Update Documents</vs-button
        >
      </vx-card>
    </vs-tab>
  </vs-tabs>
  <br><br>
     </vue-perfect-scrollbar>

</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Query, Predicate } from '@syncfusion/ej2-data';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vSelect from 'vue-select';
import { getBaseURL } from '@/config.js';

export default {
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect,
  },
  data() {
    return {
      quickSelect: null,
      fleetConfig: null,
      popupActive: false,
      refreshKey: 0,
      isLoading: true,
      driverId: this.$route.params.driverId,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue: true,
      loadingWizard: false,
      errorMsg: null,
      driverAlarm: [],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      selectedUnit: null,
      driverInfo: {
        assetId: -1,
        plate: null,
        type: '',
        subType: '',
        brand: '',
        model: '',
        industry: null,
        class: null,
        vehicleImages: [],
      },
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
    };
  },
  computed: {},
  methods: {
    vehicleImagesUpload(files, response) {
      this.driverInfo.vehicleImages.push(response.path);
    },
    vehicleDocumentsUpload(files, response) {
      this.driverInfo.vehicleImages.push(response.path);
    },
    addRecord() {
      this.fleetMaintenance.push({
        type: '',
        subtype: '',
        date: '',
        documents: [],
        remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      });
    },

    updateFleets() {
      const self = this;

      self.$http
        .patch(`fleetsSingle/${self.driverId}`, {
          driverInfo: self.driverInfo,
          driverAlarm: self.driverAlarm,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.getDrivers();

            self.isLoading = false;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    getDrivers() {
      const self = this;

      self.$http
        .get(`driversSingle/${self.driverId}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.driverInfo = JSON.parse(
              response.data.driverDetails.driverInfo,
            );
            self.driverAlarm = JSON.parse(
              response.data.driverDetails.driverAlarm,
            );
            self.refreshKey++;
            self.isLoading = false;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
  },
  created() {},
  watch: {},
  mounted() {
    this.getDrivers();
  },
};
</script>

<style lang="scss" scoped>
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
